import { useInputParameters } from '../../helpers/useInputParameters';
import './index.css';

const InputsInfoBar = () => {
  const inputs = useInputParameters();

  return (
    <section className="inputsInfo">
      {Object.entries(inputs).map((entry) => (
        <span key={`inputsInfo-${entry[0]}`}>
          <b>{entry[0]}: </b>
          {entry[1] ?? 'null'}
        </span>
      ))}
    </section>
  );
};

export default InputsInfoBar;
